export type Location = { slug: string; location: string; totalVolume: number; keywords: string[]; };

export const locations: Location[] = [
  {"slug": "las-vegas-seo", "location": "Las Vegas", "totalVolume": 0, "keywords": ["bankruptcy lawyers in Las Vegas", "personal injury attorneys near the Strip", "criminal defense lawyers for visitors", "law firms with Henderson offices", "car accident lawyers in Clark County"]},
  {"slug": "scottsdale-seo", "location": "Scottsdale", "totalVolume": 0, "keywords": ["personal injury lawyers in Scottsdale", "estate planning attorneys in the East Valley", "DUI lawyers near Old Town", "business attorneys with local offices", "family law firms serving Paradise Valley"]},
  {"slug": "minneapolis-seo", "location": "Minneapolis", "totalVolume": 0, "keywords": ["DWI lawyers in Minneapolis", "personal injury attorneys in the Twin Cities", "family lawyers near Edina", "employment attorneys with downtown offices", "immigration lawyers serving St. Paul"]},
  {"slug": "kansas-city-seo", "location": "Kansas City", "totalVolume": 0, "keywords": ["personal injury lawyers in Kansas City", "car accident attorneys in Overland Park", "workers' comp lawyers on the Missouri side", "family law firms in Johnson County", "criminal defense attorneys near Independence"]},
  {"slug": "baltimore-seo", "location": "Baltimore", "totalVolume": 0, "keywords": ["personal injury lawyers in Baltimore", "DUI attorneys in Baltimore County", "workers' comp lawyers near the harbor", "family law firms serving Columbia", "medical malpractice attorneys with local offices"]},
  {"slug": "charlotte-seo", "location": "Charlotte", "totalVolume": 0, "keywords": ["family law attorneys in Charlotte", "real estate closing lawyers in Mecklenburg County", "injury lawyers near Uptown", "business attorneys with South End offices", "DWI lawyers serving Huntersville"]},
  {"slug": "nashville-seo", "location": "Nashville", "totalVolume": 0, "keywords": ["divorce lawyers in Nashville", "child custody attorneys in Davidson County", "injury lawyers near Music Row", "estate planning firms serving Franklin", "entertainment attorneys with downtown offices"]},

  {
    "slug": "arizona-seo",
    "location": "Arizona",
    "totalVolume": 20,
    "keywords": [
      "arizona lawyer seo"
    ]
  },
  {
    "slug": "arkansas-seo",
    "location": "Arkansas",
    "totalVolume": 10,
    "keywords": [
      "arkansas lawyer seo services"
    ]
  },
  {
    "slug": "atlanta-seo",
    "location": "Atlanta",
    "totalVolume": 50,
    "keywords": [
      "lawyer seo atlanta"
    ]
  },
  {
    "slug": "austin-seo",
    "location": "Austin",
    "totalVolume": 720,
    "keywords": [
      "austin lawyer seo company",
      "austin lawyer seo marketing",
      "lawyer seo company austin",
      "lawyer seo agency austin",
      "seo agency for lawyer austin",
      "seo for lawyer austin",
      "lawyer seo marketing austin",
      "lawyer seo austin",
      "austin lawyer seo",
      "lawyer seo company austin tx",
      "lawyer seo services austin tx"
    ]
  },
  {
    "slug": "boston-seo",
    "location": "Boston",
    "totalVolume": 0,
    "keywords": [
      "boston lawyer seo",
      "boston lawyer seo company",
      "lawyer seo boston"
    ]
  },
  {
    "slug": "chicago-seo",
    "location": "Chicago",
    "totalVolume": 180,
    "keywords": [
      "lawyer seo chicago",
      "lawyer seo services chicago",
      "chicago lawyer seo",
      "chicago lawyer seo agency",
      "chicago lawyer seo company"
    ]
  },
  {
    "slug": "cleveland-seo",
    "location": "Cleveland",
    "totalVolume": 320,
    "keywords": [
      "cleveland lawyer seo marketing",
      "lawyer seo services cleveland oh",
      "lawyer seo cleveland oh",
      "seo for lawyer cleveland oh"
    ]
  },
  {
    "slug": "connecticut-seo",
    "location": "Connecticut",
    "totalVolume": 40,
    "keywords": [
      "connecticut lawyer seo expert",
      "connecticut lawyer seo agency",
      "connecticut lawyer seo company"
    ]
  },
  {
    "slug": "dallas-seo",
    "location": "Dallas",
    "totalVolume": 10,
    "keywords": [
      "lawyer seo dallas",
      "dallas lawyer seo agency",
      "dallas lawyer seo company",
      "lawyer seo arlington",
      "lawyer seo marketing dallas"
    ]
  },
  {
    "slug": "delaware-seo",
    "location": "Delaware",
    "totalVolume": 10,
    "keywords": [
      "delaware lawyer seo expert"
    ]
  },
  {
    "slug": "denver-seo",
    "location": "Denver",
    "totalVolume": 10,
    "keywords": [
      "lawyer seo denver"
    ]
  },
  {
    "slug": "florida-seo",
    "location": "Florida",
    "totalVolume": 320,
    "keywords": [
      "lawyer seo company florida",
      "lawyer seo expert florida",
      "lawyer seo marketing florida",
      "lawyer seo florida",
      "jupiter lawyer seo",
      "lawyer seo jupiter",
      "lawyer seo jupiter fl",
      "seo for lawyer fort lauderdale",
      "florida lawyer seo expert",
      "delray beach lawyer seo",
      "lawyer seo west palm beach"
    ]
  },
  {
    "slug": "fresno-seo",
    "location": "Fresno",
    "totalVolume": 20,
    "keywords": [
      "fresno lawyer seo"
    ]
  },
  {
    "slug": "georgia-seo",
    "location": "Georgia",
    "totalVolume": 190,
    "keywords": [
      "georgia lawyer seo",
      "lawyer seo georgia"
    ]
  },
  {
    "slug": "houston-seo",
    "location": "Houston",
    "totalVolume": 1230,
    "keywords": [
      "lawyer seo houston",
      "houston lawyer seo marketing",
      "lawyer seo company houston",
      "houston lawyer seo",
      "houston lawyer seo company",
      "lawyer seo marketing houston",
      "houston lawyer seo digital marketing",
      "houston seo lawyer",
      "houston lawyer seo agency"
    ]
  },
  {
    "slug": "illinois-seo",
    "location": "Illinois",
    "totalVolume": 10,
    "keywords": [
      "illinois lawyer seo services"
    ]
  },
  {
    "slug": "indiana-seo",
    "location": "Indiana",
    "totalVolume": 80,
    "keywords": [
      "indianapolis lawyer seo",
      "indiana attorney lawyer seo",
      "indiana lawyer seo analysis",
      "indiana lawyer seo"
    ]
  },
  {
    "slug": "iowa-seo",
    "location": "Iowa",
    "totalVolume": 20,
    "keywords": [
      "iowa lawyer seo expert",
      "iowa lawyer seo services"
    ]
  },
  {
    "slug": "jacksonville-seo",
    "location": "Jacksonville",
    "totalVolume": 60,
    "keywords": [
      "lawyer seo company jacksonville florida",
      "lawyer seo jacksonville",
      "lawyer seo expert jacksonville"
    ]
  },
  {
    "slug": "kansas-seo",
    "location": "Kansas",
    "totalVolume": 10,
    "keywords": [
      "kansas lawyer seo consultants"
    ]
  },
  {
    "slug": "long-island-seo",
    "location": "Long Island",
    "totalVolume": 60,
    "keywords": [
      "lawyer seo long island",
      "long island lawyer seo"
    ]
  },
  {
    "slug": "los-angeles-seo",
    "location": "Los Angeles",
    "totalVolume": 350,
    "keywords": [
      "los angeles lawyer seo",
      "lawyer seo agency los angeles",
      "lawyer seo company los angeles",
      "seo agency for lawyer los angeles",
      "seo for lawyer los angeles",
      "lawyer seo los angeles",
      "glendale az lawyer seo",
      "glendale lawyer seo",
      "long beach lawyer seo",
      "seo for lawyer in los angeles",
      "los angeles lawyer seo company",
      "seo for a lawyer in los angeles"
    ]
  },
  {
    "slug": "louisiana-seo",
    "location": "Louisiana",
    "totalVolume": 100,
    "keywords": [
      "new orleans lawyer seo marketing",
      "louisiana lawyer seo expert",
      "louisiana lawyer seo company"
    ]
  },
  {
    "slug": "maryland-seo",
    "location": "Maryland",
    "totalVolume": 10,
    "keywords": [
      "maryland lawyer seo expert"
    ]
  },
  {
    "slug": "miami-seo",
    "location": "Miami",
    "totalVolume": 160,
    "keywords": [
      "lawyer seo miami",
      "miami lawyer seo",
      "lawyer miami seo",
      "seo for lawyer miami",
      "seo lawyer miami"
    ]
  },
  {
    "slug": "michigan-seo",
    "location": "Michigan",
    "totalVolume": 10,
    "keywords": [
      "michigan lawyer seo services",
      "detroit lawyer seo",
      "lawyer seo detroit"
    ]
  },
  {
    "slug": "minnesota-seo",
    "location": "Minnesota",
    "totalVolume": 70,
    "keywords": [
      "lawyer seo minnesota",
      "lawyer seo minneapolis",
      "minnesota lawyer seo consultants"
    ]
  },
  {
    "slug": "montana-seo",
    "location": "Montana",
    "totalVolume": 30,
    "keywords": [
      "montana lawyer seo agency",
      "montana lawyer seo company",
      "montana lawyer seo consultants"
    ]
  },
  {
    "slug": "nevada-seo",
    "location": "Nevada",
    "totalVolume": 30,
    "keywords": [
      "nevada lawyer seo services",
      "nevada lawyer seo consultants"
    ]
  },
  {
    "slug": "new-hampshire-seo",
    "location": "New Hampshire",
    "totalVolume": 30,
    "keywords": [
      "new hampshire lawyer seo services",
      "new hampshire lawyer seo company"
    ]
  },
  {
    "slug": "new-mexico-seo",
    "location": "New Mexico",
    "totalVolume": 10,
    "keywords": [
      "new mexico lawyer seo agency",
      "albuquerque lawyer seo",
      "albuquerque seo lawyer",
      "lawyer seo new mexico",
      "seo lawyer new mexico"
    ]
  },
  {
    "slug": "new-york-seo",
    "location": "New York",
    "totalVolume": 10,
    "keywords": [
      "new york lawyer seo company",
      "new york lawyer seo agency"
    ]
  },
  {
    "slug": "north-carolina-seo",
    "location": "North Carolina",
    "totalVolume": 10,
    "keywords": [
      "north carolina lawyer seo agency",
      "charlotte lawyer seo company",
      "lawyer seo charlotte nc"
    ]
  },
  {
    "slug": "north-dakota-seo",
    "location": "North Dakota",
    "totalVolume": 30,
    "keywords": [
      "north dakota lawyer seo company",
      "north dakota lawyer seo consultants",
      "north dakota lawyer seo services"
    ]
  },
  {
    "slug": "ohio-seo",
    "location": "Ohio",
    "totalVolume": 10,
    "keywords": [
      "ohio lawyer seo company",
      "columbus lawyer seo agency",
      "columbus lawyer seo company"
    ]
  },
  {
    "slug": "orlando-seo",
    "location": "Orlando",
    "totalVolume": 10,
    "keywords": [
      "lawyer seo orlando"
    ]
  },
  {
    "slug": "pennsylvania-seo",
    "location": "Pennsylvania",
    "totalVolume": 40,
    "keywords": [
      "pennsylvania lawyer seo services",
      "pennsylvania lawyer seo agency",
      "pennsylvania lawyer seo expert"
    ]
  },
  {
    "slug": "peoria-seo",
    "location": "Peoria",
    "totalVolume": 60,
    "keywords": [
      "peoria lawyer seo",
      "peoria lawyer seo services"
    ]
  },
  {
    "slug": "philadelphia-seo",
    "location": "Philadelphia",
    "totalVolume": 0,
    "keywords": [
      "lawyer seo philadelphia",
      "philadelphia lawyer seo",
      "philadelphia lawyer seo agency",
      "philadelphia lawyer seo company",
      "philadelphia lawyer seo firm"
    ]
  },
  {
    "slug": "phoenix-seo",
    "location": "Phoenix",
    "totalVolume": 60,
    "keywords": [
      "lawyer seo phoenix",
      "lawyer seo services phoenix",
      "lawyer seo agency phoenix",
      "phoenix lawyer seo agency",
      "phoenix lawyer seo company"
    ]
  },
  {
    "slug": "phoenix-seo",
    "location": "Phoenix Metro",
    "totalVolume": 280,
    "keywords": [
      "avondale lawyer seo",
      "gilbert lawyer seo",
      "gilbert lawyer seo services",
      "goodyear lawyer seo",
      "lawyer seo avondale",
      "lawyer seo chandler",
      "lawyer seo goodyear",
      "lawyer seo scottsdale",
      "lawyer seo services chandler",
      "lawyer seo services scottsdale",
      "lawyer seo services tempe",
      "lawyer seo tempe"
    ]
  },
  {
    "slug": "portland-seo",
    "location": "Portland",
    "totalVolume": 90,
    "keywords": [
      "portland lawyer seo",
      "lawyer seo portland",
      "lawyer seo services beaverton",
      "lawyer seo services portland"
    ]
  },
  {
    "slug": "sacramento-seo",
    "location": "Sacramento",
    "totalVolume": 30,
    "keywords": [
      "sacramento lawyer seo"
    ]
  },
  {
    "slug": "san-antonio-seo",
    "location": "San Antonio",
    "totalVolume": 0,
    "keywords": [
      "san antonio lawyer seo agency",
      "san antonio lawyer seo company"
    ]
  },
  {
    "slug": "san-bernardino-seo",
    "location": "San Bernardino",
    "totalVolume": 30,
    "keywords": [
      "san bernardino lawyer seo"
    ]
  },
  {
    "slug": "san-diego-seo",
    "location": "San Diego",
    "totalVolume": 110,
    "keywords": [
      "lawyer seo chula vista",
      "chula vista lawyer seo",
      "san diego lawyer seo",
      "sd lawyer seo",
      "seo for lawyer san diego"
    ]
  },
  {
    "slug": "san-francisco-seo",
    "location": "San Francisco",
    "totalVolume": 150,
    "keywords": [
      "best lawyer seo company san francisco",
      "san francisco lawyer seo",
      "fremont lawyer seo",
      "lawyer seo company san francisco",
      "lawyer seo consultant san francisco",
      "lawyer seo services san francisco",
      "lawyer seo agency san francisco"
    ]
  },
  {
    "slug": "santa-ana-seo",
    "location": "Santa Ana",
    "totalVolume": 30,
    "keywords": [
      "santa ana lawyer seo"
    ]
  },
  {
    "slug": "seattle-seo",
    "location": "Seattle",
    "totalVolume": 10,
    "keywords": [
      "lawyer seo seattle",
      "lawyer seo seattle dental seo expert seattle"
    ]
  },
  {
    "slug": "south-carolina-seo",
    "location": "South Carolina",
    "totalVolume": 290,
    "keywords": [
      "lawyer seo south carolina",
      "lawyer seo myrtle beach",
      "myrtle beach lawyer seo",
      "lawyer seo agency in sc",
      "lawyer seo bluffton",
      "south carolina lawyer seo services",
      "lawyer seo charleston county",
      "lawyer seo charleston sc",
      "lawyer seo expert charleston county",
      "lawyer seo expert charleston sc",
      "lawyer seo expert lowcountry sc",
      "lawyer seo expert south carolina"
    ]
  },
  {
    "slug": "stockton-seo",
    "location": "Stockton",
    "totalVolume": 30,
    "keywords": [
      "lawyer seo stockton",
      "stockton lawyer seo"
    ]
  },
  {
    "slug": "tampa-seo",
    "location": "Tampa",
    "totalVolume": 180,
    "keywords": [
      "lawyer seo agency tampa",
      "lawyer seo company tampa",
      "seo agency for lawyer tampa",
      "seo for lawyer tampa",
      "lawyer seo st petersburg",
      "lawyer seo tampa",
      "clearwater lawyer seo",
      "tampa lawyer seo"
    ]
  },
  {
    "slug": "tennessee-seo",
    "location": "Tennessee",
    "totalVolume": 40,
    "keywords": [
      "tennessee lawyer seo company",
      "tennessee lawyer seo consultants",
      "tennessee lawyer seo expert",
      "tennessee lawyer seo services",
      "nashville lawyer seo agency",
      "nashville lawyer seo company"
    ]
  },
  {
    "slug": "texas-seo",
    "location": "Texas",
    "totalVolume": 0,
    "keywords": [
      "texas lawyer seo"
    ]
  },
  {
    "slug": "tucson-seo",
    "location": "Tucson/AZ",
    "totalVolume": 160,
    "keywords": [
      "lawyer seo agency tucson",
      "lawyer seo flagstaff",
      "lawyer seo yuma",
      "seo for lawyer tucson",
      "tucson lawyer seo",
      "tucson lawyer seo services",
      "yuma lawyer seo",
      "flagstaff lawyer seo",
      "lawyer seo tucson"
    ]
  },
  {
    "slug": "tulsa-seo",
    "location": "Tulsa",
    "totalVolume": 0,
    "keywords": [
      "lawyer seo tulsa"
    ]
  },
  {
    "slug": "ventura-county-seo",
    "location": "Ventura County",
    "totalVolume": 120,
    "keywords": [
      "camarillo lawyer seo",
      "ventura county lawyer seo",
      "ventura lawyer seo",
      "agoura hills lawyer seo",
      "moorpark lawyer seo",
      "oxnard lawyer seo",
      "simi valley lawyer seo",
      "thousand oaks lawyer seo",
      "westlake village lawyer seo"
    ]
  },
  {
    "slug": "vermont-seo",
    "location": "Vermont",
    "totalVolume": 20,
    "keywords": [
      "vermont lawyer seo agency",
      "vermont lawyer seo services",
      "vermont lawyer seo expert"
    ]
  },
  {
    "slug": "virginia-seo",
    "location": "Virginia",
    "totalVolume": 10,
    "keywords": [
      "virginia lawyer seo company"
    ]
  },
  {
    "slug": "washington-dc-seo",
    "location": "Washington DC",
    "totalVolume": 70,
    "keywords": [
      "washington lawyer seo marketing"
    ]
  },
  {
    "slug": "west-virginia-seo",
    "location": "West Virginia",
    "totalVolume": 10,
    "keywords": [
      "west virginia lawyer seo consultants"
    ]
  },
  {
    "slug": "wisconsin-seo",
    "location": "Wisconsin",
    "totalVolume": 20,
    "keywords": [
      "wisconsin lawyer seo agency",
      "wisconsin lawyer seo services"
    ]
  },
  {
    "slug": "wyoming-seo",
    "location": "Wyoming",
    "totalVolume": 20,
    "keywords": [
      "wyoming lawyer seo consultants",
      "wyoming lawyer seo expert"
    ]
  }
];

export const getLocation = (slug: string) => locations.find(l => l.slug === slug);
